__turbopack_context__.v({
  "bordered": "HB5Z3q_bordered",
  "borderless": "HB5Z3q_borderless",
  "button": "HB5Z3q_button",
  "disabled": "HB5Z3q_disabled",
  "font-accent": "HB5Z3q_font-accent",
  "font-special": "HB5Z3q_font-special",
  "namespace": "HB5Z3q_namespace",
  "primary": "HB5Z3q_primary",
  "short": "HB5Z3q_short",
  "standard": "HB5Z3q_standard",
});
